import {Map, List, fromJS} from 'immutable';
import {ActionTypes} from './Actions';
import _ from 'lodash';

const initialState = {
  stones: List(),
  selectedStones: {},
  term: '',
  page: 0,
  totalPages: 1
}

const __setStones = (state, {payload}) => {
  let stones = fromJS(payload.rows);

  _.forEach(state.selectedStones, (v, stoneId) => {
    const idx = stones.findIndex(s => s.get('id') === +stoneId);
    if (idx !== -1)
      stones = stones.setIn([idx, 'checked'], true);
  })

  return {...state, stones, totalPages: payload.totalPages, page: payload.page};
}

const __selectStone = (state, {payload}) => {
  const {stone, select} = payload;

  const selectedStones = state.selectedStones;
  if (!select)
    delete selectedStones[stone.id];
  else
    selectedStones[stone.id] = true;

  let stones = state.stones;
  const idx = stones.findIndex(s => s.get('id') === stone.id);
  stones = stones.setIn([idx, 'checked'], select);
  return {...state, stones, selectedStones, allSelected: false};
}

const __selectAllStones = (state, {payload}) => {
  const {select} = payload;
  const {selectedStones} = state;
  let stones = state.stones.map(s => {
    s = s.set('checked', select);
    if (select)
      selectedStones[s.get('id')] = true;
    else
      delete selectedStones[s.get('id')];
    return s;
  });

  return {...state, stones, selectedStones};
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_STONES_LOADING:
      const {term, page} = action.payload;
      return {...state, term, page};
    case ActionTypes.GET_STONES_LOADED:
      return __setStones(state, action);
    case ActionTypes.MARK_STONE_CHECKED:
      return __selectStone(state, action);
    case ActionTypes.MARK_ALL_STONES_CHECKED:
      const {select} = action.payload;
      return __selectAllStones(state, action);
  }

  return state;
}

/**
 * Returns a JS array of all checked stones
 * @param state
 * @returns {any}
 */
export const getSelectedStones = (state) => {
  return state.stones.filter(s => s.get('checked')).toJS();
}
